import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { styled, Box } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import HMO from "../Images/HMO.png"
import './Modal.css';


// https://mui.com/x/introduction/licensing/
// MUI has MIT lisencing as of 02/11/2023
/*
Sourced from MUI:
MIT vs. commercial licenses

The MUI team has been building MIT-licensed React components since 2014 with Material UI. We are committed to the continued advancement of the open-source libraries. 
Anything we release under an MIT license will remain MIT-licensed forever. You can learn more about our stewardship ethos in this document from our company handbook.

We offer commercial licenses to developers who need the most advanced features that cannot be easily maintained by the open-source community. Commercial licenses 
enable us to support a full-time staff of engineers, which is simply not possible through the MIT model.

Rest assured that when we release features commercially, it's only because we believe that you will not find a better MIT-licensed alternative 
anywhere else.

*/

export default function ModalUnstyled() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <TriggerButton type="button" onClick={handleOpen}>
        Want to see an example?
      </TriggerButton>
      <Modal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
            <img className = "modal-img" src = {HMO}/>
        </ModalContent>
      </Modal>
    </div>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ 'MuiBackdrop-open': open }, className)}
      ref={ref}
      {...other}
    />
  );
});

Backdrop.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.8);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
  zIndex: 999999,
};

const ModalContent = styled(Box)(
);

const TriggerButton = styled('button')(
  ({ theme }) => `
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #382e0d;
  font-style: italic;
  font-weight: 400;
  font-size: 90%;
  margin-bottom: 40px;
  text-decoration: underline;
  text-underline-offset: 10px;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    color: #817961;
  }
`,
);